import Nav from "./Nav";
export default function Header() {
  return (
    <header className="header">
      <Nav />
    </header>
  );
}
